module.exports = [
	{
		"name": "Bottom",
		"range_short": "< $10k",
		"range_long": "< $10,000",
		"index": 0
	},
	{
		"name": "Middle",
		"range_short": "$10k - 100k",
		"range_long": "$10,000 - 100,000",
		"index": 1
	},
	{
		"name": "Affluent",
		"range_short": "$100k - 1mn",
		"range_long": "$100,000 - 1 million",
		"index": 2
	},
	{
		"name": "HNWIs",
		"range_short": "> $1mn",
		"range_long": "> 1 million",
		"index": 3
	},
	{
		"name": "Ultra-HNWIs",
		"range_short": "> $50mn",
		"range_long": "> 50 million",
		"index": 4
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/nav-links-strip/sections-list.json
// module id = 121
// module chunks = 0